const translations = {
  "en": {
    "Answers from your real numbers. Unlock full access.": "Answers from your real numbers. Unlock full access.",
    "Coming soon, please choose other ways.": "Coming soon, please choose other ways.",
    "Flag risks before they land": "Flag risks before they land",
    "Link an account and I'll answer with your actual data.": "Link an account and I'll answer with your actual data.",
    "Net worth, spending and accounts in one place": "Net worth, spending and accounts in one place",
    "Track holdings, prices and returns in real time": "Track holdings, prices and returns in real time"
  },
  "zh-tw": {
    "Answers from your real numbers. Unlock full access.": "源自您的實際數據。解鎖完整存取。",
    "Coming soon, please choose other ways.": "即將推出，請選擇其他方式。",
    "Flag risks before they land": "在風險發生前預先警示",
    "Link an account and I'll answer with your actual data.": "連結帳戶，我將以您的實際資料為您解答。",
    "Net worth, spending and accounts in one place": "淨值、支出與帳戶一處掌握",
    "Track holdings, prices and returns in real time": "即時追蹤持倉、價格與報酬"
  }
};

export default translations;
